var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"notification-app-name"},[_vm._v("\n    "+_vm._s(_vm.prefix)+_vm._s(_vm.app_name)+_vm._s(_vm.suffix)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }